<div class="prescription-list-wrapper">
  <table class="prescription-list table table-bordered table-hover"
    [ngClass]="{ 'table-sm': small }">
    <thead [ngClass]="{ 'table-dark': dark }">
      <tr>
        <th>&nbsp;</th>
        @if (forProvider) {
          <th>PATIENT</th>
        }
        <th>DRUG</th>
        @if (!forProvider) {
          <th>PRESCRIBER</th>
        }
        @if (!forProvider) {
          <th>PRESCRIBER SPECIALITY</th>
        }
        <th class="text-end">WRITTEN DATE</th>
        @if (showEstimatedValue) {
          <th class="text-end">EST. VALUE</th>
        }
        <th>SOURCE</th>
        <th class="text-center">NEEDS EVIDENCE</th>
        <th class="text-center">PENDING</th>
        <th class="text-center">REJECTED</th>
        <th class="text-center">CE REVIEW</th>
        <th class="text-center">VERIFIED</th>
        <th class="text-center">REVERSED</th>
        <th class="text-center">OTHER</th>
        <th class="text-center">TOTAL</th>
      </tr>
    </thead>
    <tbody>
      @for (prescription of prescriptions; track prescription.id) {
        <tr
          app-prescription-list-row
          class="prescription-list-row"
          [prescription]="prescription"
          [collapsed]="isPrescriptionCollapsed(prescription)"
          [showEstimatedValue]="showEstimatedValue"
          [forProvider]="forProvider"
          [ngClass]="{ 'table-light': !isPrescriptionCollapsed(prescription) }"
          (click)="onToggleClick(prescription)"
        ></tr>
        <tr
          app-prescription-list-row-detail
          class="prescription-item-row table-light"
          [prescription]="prescription"
          [activeCaptureId]="activeCaptureId"
          [isOpen]="!isPrescriptionCollapsed(prescription)"
          [ngClass]="{ collapse: isPrescriptionCollapsed(prescription) }"
        ></tr>
      }
    </tbody>
  </table>
</div>
